import { useTranslation } from 'react-i18next';
import useOrderFlow from '../../../hooks/order/useOrderFlow';
import { REDUX_STORE_SLICES } from '../../../services/exports/Constants';
import useStore from '../../../hooks/store/useStore';
import useBasket from '../../../hooks/basket/useBasket';
import { Mail } from 'lucide-react';
import { Checkbox } from '../../ui/checkbox';
import Section from './Section';

export default function MarketingSubscriptionSection() {
  const { t } = useTranslation(undefined, { keyPrefix: 'Components:Marketing:MarketingSubscriptionConsent' });

  const { localData, update } = useOrderFlow();
  const { items } = useBasket();
  const { profile } = useStore<REDUX_STORE_SLICES.PROFILE>(REDUX_STORE_SLICES.PROFILE);

  return (
    <Section
      hideDivider
      show={!profile?.is_marketing_subscriber && items.length > 0}
      className="!py-none px-md"
      containerClassName="pb-md"
    >
      <div className="flex w-full items-start gap-sm p-md border-xs rounded-lg bg-brand-card border-mobile-secondary cursor-pointer">
        <Checkbox
          checked={localData.marketing_consent}
          onCheckedChange={(checked) => update('marketing_consent', checked)}
          id="is_marketing_subscriber"
          className="mt-[6px]"
        />
        <div className="cursor-pointer">
          <label htmlFor="is_marketing_subscriber" className="my-auto flex flex-col gap-1 cursor-pointer">
            <div className="flex items-center gap-2">
              <Mail className="h-4 w-4 text-brand-text-secondary lg:block hidden" />
              <h6 className="text-sm">{t('title')}</h6>
            </div>
            <p className="text-sm text-brand-text-secondary">{t('form.marketing_subscription.label')}</p>
          </label>
        </div>
      </div>
    </Section>
  );
}
